import { Helmet } from 'react-helmet-async';
import Footer from '../page-main/footer';
import InfoStat from '../page-main/info_stat';
import Navbar from '../Navbar';
import Hero from '../Hero';
import ProductMain1 from '../page-main/product_main_1';

export default function Home() {
  // Schema.org para Homepage
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Adrox Perú",
    "alternateName": "Adrox",
    "url": "https://adrox.pe",
    "description": "Empresa líder en desarrollo de software, inteligencia artificial y transformación digital en Perú. Soluciones tecnológicas innovadoras para empresas.",
    "inLanguage": "es-PE",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://adrox.pe/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Adrox Perú",
    "legalName": "Adrox Perú S.A.C.",
    "url": "https://adrox.pe",
    "logo": "https://adrox.pe/images/adrox-logo.png",
    "foundingDate": "2020",
    "founders": [
      {
        "@type": "Person",
        "name": "Equipo Adrox"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "PE",
      "addressLocality": "Lima",
      "addressRegion": "Lima"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+51-933-534-235",
        "contactType": "customer service",
        "email": "contacto@adrox.pe",
        "areaServed": ["PE", "BO", "EC"],
        "availableLanguage": ["Spanish", "English"],
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+51-933-534-235",
        "contactType": "sales",
        "areaServed": ["PE", "BO", "EC"],
        "availableLanguage": ["Spanish"]
      }
    ],
    "sameAs": [
      "https://wa.me/+51933534235",
      "https://www.linkedin.com/company/adrox-peru",
      "https://www.facebook.com/adroxperu"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "100",
      "bestRating": "5"
    },
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "15"
    }
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Desarrollo de Software",
    "provider": {
      "@type": "Organization",
      "name": "Adrox Perú",
      "url": "https://adrox.pe"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Perú"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Servicios de Tecnología",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Desarrollo de Software Personalizado",
            "description": "Desarrollo de aplicaciones web y móviles a medida"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Inteligencia Artificial",
            "description": "Soluciones de IA y Machine Learning"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Transformación Digital",
            "description": "Consultoría y servicios de transformación digital empresarial"
          }
        }
      ]
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": "https://adrox.pe"
      }
    ]
  };

  return (
    <>
      <Helmet>
        {/* Meta Tags Básicos */}
        <title>Adrox Perú | Desarrollo de Software, IA y Transformación Digital en Lima</title>
        <meta name="description" content="Desarrollo de software e IA en Perú. Implementamos soluciones tecnológicas innovadoras para empresas. 150+ proyectos, 100+ clientes satisfechos. ¡Cotiza gratis!" />
        <meta name="keywords" content="desarrollo de software Perú, empresa de software Lima, inteligencia artificial Perú, transformación digital, desarrollo web Perú, desarrollo móvil, Odoo Perú, Django, React, FastAPI, soluciones tecnológicas, Adrox" />
        
        {/* Meta Tags Avanzados */}
        <meta name="author" content="Adrox Perú" />
        <meta name="publisher" content="Adrox Perú" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="3 days" />
        <meta name="rating" content="general" />
        <meta name="distribution" content="global" />
        <meta name="coverage" content="Worldwide" />
        <meta name="target" content="all" />
        
        {/* Business Info */}
        <meta name="page-topic" content="Software Development, Technology, Artificial Intelligence" />
        <meta name="page-type" content="Homepage" />
        <meta name="audience" content="Businesses, Entrepreneurs, Startups" />
        
        {/* Geo Tags para SEO Local */}
        <meta name="geo.region" content="PE-LIM" />
        <meta name="geo.placename" content="Lima, Perú" />
        <meta name="geo.position" content="-12.0464;-77.0428" />
        <meta name="ICBM" content="-12.0464, -77.0428" />
        
        {/* Open Graph / Facebook - Mejorado */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.adrox.top" />
        <meta property="og:title" content="Adrox Perú | Desarrollo de Software e Inteligencia Artificial" />
        <meta property="og:description" content="Empresa líder en desarrollo de software, IA y transformación digital en Perú. 150+ proyectos completados, 100+ clientes satisfechos. Tecnología de vanguardia." />
        <meta property="og:image" content="https://adrox.pe/images/adrox-logo.png" />
        <meta property="og:image:secure_url" content="https://adrox.pe/images/adrox-logo.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Adrox Perú - Desarrollo de Software e Inteligencia Artificial" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:locale" content="es_PE" />
        <meta property="og:locale:alternate" content="es_BO" />
        <meta property="og:locale:alternate" content="es_EC" />
        <meta property="og:locale:alternate" content="en_US" />
        <meta property="og:site_name" content="Adrox Perú" />
        <meta property="og:updated_time" content={new Date().toISOString()} />
        
        {/* Twitter Cards - Completo */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@AdroxPeru" />
        <meta name="twitter:creator" content="@AdroxPeru" />
        <meta name="twitter:title" content="Adrox Perú | Desarrollo de Software e IA" />
        <meta name="twitter:description" content="Empresa líder en desarrollo de software e inteligencia artificial en Perú. Transformación digital para tu negocio." />
        <meta name="twitter:image" content="https://adrox.pe/images/adrox-logo.png" />
        <meta name="twitter:image:alt" content="Logo Adrox Perú" />
        <meta name="twitter:domain" content="adrox.top" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.adrox.top" />
        
        {/* Alternate URLs */}
        <link rel="alternate" hrefLang="es-PE" href="https://www.adrox.top" />
        <link rel="alternate" hrefLang="es" href="https://www.adrox.top" />
        <link rel="alternate" hrefLang="x-default" href="https://www.adrox.top" />
        
        {/* DNS Prefetch y Preconnect */}
        <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
        
        {/* Idioma */}
        <meta httpEquiv="content-language" content="es-PE" />
        <html lang="es-PE" />
        
        {/* Mobile & PWA */}
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Adrox" />
        <meta name="application-name" content="Adrox Perú" />
        <meta name="msapplication-TileColor" content="#00b4d8" />
        <meta name="theme-color" content="#00b4d8" />
        <meta name="msapplication-navbutton-color" content="#00b4d8" />
        
        {/* Preload Critical Resources */}
        <link rel="preload" href="/images/adrox-logo.png" as="image" />
        <link rel="preload" href="/images/lap-odoo.svg" as="image" />
        
        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <div>
      <Navbar />
      <Hero />
      <InfoStat />
      <ProductMain1 />
      <Footer/>
      </div>
    </>
  );
}
